import { createSelector } from 'reselect';

import { StoreState } from '../types/store';

import {
    getCurrentCompany,
    getCurrentCompanyBillingCompanyConfig,
    getCurrentCompanyConfig,
    getCurrentUser,
    getCurrentUserRole,
} from './app.selectors';

import { isFopCompany } from '../lib/company';

export const getSlice = (state: StoreState) => state.successVerifiedUser;

export const getDisplayStatus = (state: StoreState) =>
    getSlice(state).displayStatus;

export const getPhoneNumberForOTPMessage = (state: StoreState) =>
    getSlice(state).phoneNumberForOTPMessage;

export const getIsEditMode = (state: StoreState) => getSlice(state).isEditMode;

export const getIsNeed2FAVerify = createSelector(
    getCurrentCompanyBillingCompanyConfig,
    getCurrentCompanyConfig,
    getCurrentUser,
    (billingConfig, companyConfig, currentUser) => {
        const is2FARequired =
            billingConfig.canEnforce2FA &&
            companyConfig.enable_2fa_for_internal_users;
        const isUserHasVerifiedPhone =
            Boolean(currentUser.phone) && Boolean(currentUser.isPhoneVerified);

        return is2FARequired && !isUserHasVerifiedPhone;
    },
);

export const getCanCloseSuccessVerifiedUser = createSelector(
    getCurrentCompany,
    getCurrentUser,
    getCurrentUserRole,
    getIsNeed2FAVerify,
    (currentCompany, currentUser, currentRole, isNeed2FAVerify) => {
        const isCurrentRolePositionAlreadyExist =
            isFopCompany({ edrpou: currentCompany.edrpou }) ||
            currentRole.position;
        const isAdditionalInfoAlreadyExist =
            currentUser.firstName &&
            currentUser.phone &&
            isCurrentRolePositionAlreadyExist;

        const isRegistrationByInvite =
            Boolean(currentUser.createdBy) && !isAdditionalInfoAlreadyExist;
        return !isNeed2FAVerify && !isRegistrationByInvite;
    },
);

export const getIsShowVerifyCodeForm = createSelector(
    getPhoneNumberForOTPMessage,
    (phoneNumberForOTPMessage) => Boolean(phoneNumberForOTPMessage),
);
